import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { UserContextService } from './user-context.service';
import { WORKSPACE_ID } from '@sentry/api-resources';

@Injectable()
export class WorkspaceHeaderInterceptor implements HttpInterceptor {
  constructor(private readonly userContextService: UserContextService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Check if the request URL contains the specified string
    if (request.url.includes('.us.auth0.com')) {
      // If it does, forward the request without modification
      return next.handle(request);
    }

    // Check if the WORKSPACE_ID header is already set
    if (request.headers.has(WORKSPACE_ID)) {
      // If it is, forward the request without modification
      return next.handle(request);
    }

    // If the request URL does not contain the specified string and no WORKSPACE_ID header is set, proceed with adding the header
    return this.userContextService.selectedWorkspace$.pipe(
      first(),
      switchMap((selectedWorkspace) => {
        const duplicateRequest = request.clone({
          headers: request.headers.set(
            WORKSPACE_ID,
            selectedWorkspace?.id ?? ''
          ),
        });
        return next.handle(duplicateRequest);
      })
    );
  }
}
